import { render, staticRenderFns } from "./DetailsDuties.vue?vue&type=template&id=1c97aa82"
import script from "./DetailsDuties.vue?vue&type=script&lang=ts"
export * from "./DetailsDuties.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDuties.vue?vue&type=style&index=0&id=1c97aa82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports